import { OskCurrencyPipe } from '@shared/pipes/osk-currency.pipe';
import { Component, computed, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AdminRestaurantStore } from '@features/admin';

@Component({
  selector: 'app-admin-restaurants',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink, OskCurrencyPipe],
  templateUrl: 'admin-restaurants.component.html',
  styleUrl: 'admin-restaurants.component.scss',
})
export class AdminRestaurantsComponent implements OnInit {
  readonly store = inject(AdminRestaurantStore);

  searchTerm = '';
  statusFilter = '';
  cuisineFilter = '';
  sortBy = 'name';

  filteredRestaurants = computed(() => {
    let restaurants = this.store.restaurants();

    if (this.searchTerm) {
      const term = this.searchTerm.toLowerCase();
      restaurants = restaurants.filter(
        (r) =>
          r.name.toLowerCase().includes(term) ||
          r.city?.toLowerCase().includes(term),
      );
    }

    if (this.statusFilter) {
      restaurants = restaurants.filter((r) => r.status === this.statusFilter);
    }

    if (this.cuisineFilter) {
      restaurants = restaurants.filter(
        (r) =>
          r.cuisineType?.toLowerCase() === this.cuisineFilter.toLowerCase(),
      );
    }

    return restaurants;
  });

  ngOnInit(): void {
    this.store.loadRestaurants();
  }

  onSearch(term: string): void {
    // Filtrage géré par computed
  }

  onFilterChange(): void {
    // Filtrage géré par computed
  }

  onSortChange(): void {
    this.store.loadRestaurants({ sortBy: this.sortBy });
  }

  refreshRestaurants(): void {
    this.store.loadRestaurants();
  }

  exportRestaurants(): void {
    const restaurants = this.filteredRestaurants();
    const csv = this.generateCSV(restaurants);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `restaurants_${new Date().toISOString().split('T')[0]}.csv`;
    link.click();
  }

  viewOrders(restaurant: any): void {
    // Navigation vers les commandes du restaurant
    console.log('Voir les commandes de', restaurant.name);
  }

  viewMenu(restaurant: any): void {
    // Navigation vers le menu du restaurant
    console.log('Voir le menu de', restaurant.name);
  }

  deleteRestaurant(restaurant: any): void {
    if (
      confirm(
        `Êtes-vous sûr de vouloir supprimer le restaurant "${restaurant.name}" ?`,
      )
    ) {
      this.store.deleteRestaurant(restaurant.id);
    }
  }

  toggleRestaurantStatus(restaurant: any): void {
    const newStatus = restaurant.status === 'active' ? 'inactive' : 'active';
    this.store.updateRestaurantStatus({ id: restaurant.id, status: newStatus });
  }

  approveRestaurant(restaurant: any): void {
    if (confirm(`Voulez-vous valider le restaurant "${restaurant.name}" ?`)) {
      this.store.approveRestaurant(restaurant.id);
    }
  }

  suspendRestaurant(restaurant: any): void {
    const reason = prompt(`Raison de la suspension de "${restaurant.name}" :`);
    if (reason) {
      this.store.suspendRestaurant({ id: restaurant.id, reason });
    }
  }

  goToPage(page: number): void {
    if (page >= 0 && page < this.store.totalPages()) {
      this.store.loadRestaurants({ page });
    }
  }

  getStatusLabel(status: string): string {
    const labels: Record<string, string> = {
      active: 'Actif',
      inactive: 'Inactif',
      pending: 'En attente',
      suspended: 'Suspendu',
    };
    return labels[status] || status;
  }

  private generateCSV(restaurants: any[]): string {
    const headers = [
      'Nom',
      'Cuisine',
      'Ville',
      'Statut',
      'Note',
      'Commandes',
      'Revenus',
    ];
    const rows = restaurants.map((r) => [
      r.name,
      r.cuisineType || 'N/A',
      r.city || 'N/A',
      this.getStatusLabel(r.status),
      r.rating,
      r.ordersCount,
      r.revenue,
    ]);

    return [headers.join(';'), ...rows.map((r) => r.join(';'))].join('\n');
  }
}
